import { medley, themedBox } from "@constants/products/detail";

const DEFAULT_COLLECTION_TYPE_FOR_FE = "collection";
export const COLLECTION_PRODUCT_TYPES = [medley, themedBox, DEFAULT_COLLECTION_TYPE_FOR_FE];
export const ITEM_PRODUCT_TYPES = {
  product: "Spree::Product",
  collection: "Spree::ProductSet",
  byo: "byo_items",
};

const cartSuccessMessages = {
  itemAddedSuccessMessage: "Your item(s) have been successfully added to the bag.",
  itemRemovedSuccessMessage: "Your item(s) have been successfully removed from the bag.",
  itemUpdatedSuccessMessage: "Your item(s) have been successfully updated in the bag.",
};

export const { itemAddedSuccessMessage, itemRemovedSuccessMessage, itemUpdatedSuccessMessage } =
  cartSuccessMessages;
export const MIN_CARD_CHARGE_IN_USD = 0.5;

export const ORDER_TYPES = {
  organizer: "Spree::OrganizerOrder",
  lead: "Spree::LeadOrder",
};

export const ORDER_TYPES_IN_RESPONSE = {
  [ORDER_TYPES.organizer]: "spreeOrganizerOrders",
  [ORDER_TYPES.lead]: "spreeLeadOrders",
};

export const ORDER_STATE_CART = "cart";

export const PRICING_MATRIX_PRICE_ID = "price-bulk-discount";

export const SWAG_PURCHASED_FROM_US_INTENT = "swag_purchased_from_us";

export const MINIMUM_CART_ITEM = 1;

export const SHIPPED_TOGETHER = "shippedTogether";
export const SHIPPED_SEPARATELY = "shippedSeparately";

export const CART_RESPONSE_TYPE = "cumulative_cart";

//cart note
export const PURCHASING_SWAG_NOTE =
  "Purchasing Swag: You’ll receive digital proofs for your items and be able to request changes if needed. Once you approve, items will go into production.";

export const ASSET_MISSING_NOTE =
  "**Some items in your cart are missing logos. Please add the logos before proceeding to checkout.";
